import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {noResultsTemplate, logoTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';

export default class CompaniesMetricScoresEdit {

  constructor() {}

  render() {

  	filterTypeahead('#accounts_search', 'accounts', '/accounts?', 550, 'generic');

	  // On typeahead select, create a filter
	  $('#accounts_search').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
      let val = suggestion.value;
      $('#hidden_account_id').val(val);
	  });
    $('#accounts_search').on('input', function() {
      if ($(this).val() === '') {
        $('#hidden_account_id').val('');
      }
    });    

    // Configuration for different filter types
    const filterConfigs = [
      {
        filterClass: '.sector-filter',
        bloodhoundName: 'sectors',
        searchUrl: '/companies/attrs/search?attr=sector&',
        containerSelector: '#selectedSectors',
        removeClass: 'remove-sector',
        dataAttribute: 'sector'
      },
      {
        filterClass: '.industry-filter',
        bloodhoundName: 'industries',
        searchUrl: '/companies/attrs/search?attr=industry&',
        containerSelector: '#selectedIndustries',
        removeClass: 'remove-industry',
        dataAttribute: 'industry'
      },
      {
        filterClass: '.country-filter',
        bloodhoundName: 'countries',
        searchUrl: '/companies/attrs/search?attr=hq_country&',
        containerSelector: '#selectedCountries',
        removeClass: 'remove-country',
        dataAttribute: 'country'
      },
      {
        filterClass: '.cap-filter',
        bloodhoundName: 'caps',
        searchUrl: '/companies/attrs/search?attr=market_cap&',
        containerSelector: '#selectedCaps',
        removeClass: 'remove-cap',
        dataAttribute: 'cap'
      }
    ];

    // Initialize typeaheads for all filter types
    filterConfigs.forEach(config => {
      filterTypeahead(config.filterClass, config.bloodhoundName, config.searchUrl, 955, 'generic');
    });

    // Generic template function for selected items
    const createItemTemplate = (suggestion, removeClass, dataAttribute) => {
      return `
        <div class="w-100 d-flex align-items-center py-2 mb-2 border-dashed-except-last">
          <div class="mr-3 font-weight-normal">${suggestion}</div>
          <div class="ml-auto ${removeClass} clickable" data-${dataAttribute}="${suggestion}">
            <svg class="svg-inline--fa fa-trash fa-w-14 text-danger" aria-hidden="true" focusable="false" data-prefix="fad" data-icon="trash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg="">
              <g class="fa-group">
                <path class="fa-secondary" fill="currentColor" d="M53.2 467L32 96h384l-21.2 371a48 48 0 0 1-47.9 45H101.1a48 48 0 0 1-47.9-45z"></path>
                <path class="fa-primary" fill="currentColor" d="M0 80V48a16 16 0 0 1 16-16h120l9.4-18.7A23.72 23.72 0 0 1 166.8 0h114.3a24 24 0 0 1 21.5 13.3L312 32h120a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16A16 16 0 0 1 0 80z"></path>
              </g>
            </svg>
          </div>
        </div>
      `;
    };

    // Generic function to handle typeahead selection
    const handleSelection = (config) => {
      $(config.filterClass).bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
        let hiddenField = $(this).closest('.form-group').find('input[type=\'hidden\']');
        let currentVal = hiddenField.val();
        
        if (currentVal.length === 0) {
          hiddenField.val(suggestion.value);
          $(config.containerSelector).append(createItemTemplate(suggestion.value, config.removeClass, config.dataAttribute));
        } else {
          let items = currentVal.split(',');
          if (!items.includes(suggestion.value)) {
            items.push(suggestion.value);
            hiddenField.val(items.join(','));
            $(config.containerSelector).append(createItemTemplate(suggestion.value, config.removeClass, config.dataAttribute));
          }
        }
        
        // Clear input and trigger search to show results again
        let $input = $(this);
        setTimeout(() => {
          $input.typeahead('val', '');
          $input.typeahead('open');
        }, 100);
      });
    };

    // Generic function to handle item removal
    const handleRemoval = (config) => {
      $(config.containerSelector).on('click', `.${config.removeClass}`, function() {
        let item = $(this).data(config.dataAttribute);
        let hiddenField = $(this).closest('.form-group').find('input[type=\'hidden\']');
        let currentVal = hiddenField.val();
        let items = currentVal.split(',');
        items = items.filter(i => i !== item);
        hiddenField.val(items.join(','));
        $(this).closest('.w-100').remove();
      });
    };

    // Set up all filter configurations
    filterConfigs.forEach(config => {
      handleSelection(config);
      handleRemoval(config);
    });

    this.initScoringOptions();

  }

  initScoringOptions() {
    const $container = $('#scoringOptionsContainer');
    const template = document.getElementById('scoringOptionTemplate');
    const $addButton = $('#addScoringOption');

    if (!$container.length || !template || !$addButton.length) { return; }

    const emptyStateHtml = '<div id="scoringOptionsEmptyState" class="text-muted small mb-3">No scoring options yet.</div>';
    const removeEmptyState = () => $('#scoringOptionsEmptyState').remove();
    const ensureEmptyState = () => {
      if (!$container.find('.scoring-option-fields').length && !$('#scoringOptionsEmptyState').length) {
        $container.prepend(emptyStateHtml);
      }
    };

    $addButton.on('click', () => {
      const uniqueId = Date.now().toString();
      const html = template.innerHTML.replace(/NEW_RECORD/g, uniqueId);
      removeEmptyState();
      $container.append(html);
    });

    $container.on('click', '.remove-scoring-option', function() {
      $(this).closest('.scoring-option-fields').remove();
      ensureEmptyState();
    });
  }

}
